export enum CaseTypes {
  CREDIT_BUREAU_FROZEN = 'CREDIT_BUREAU_FROZEN',
  FRAUD_ALERT = 'FRAUD_ALERT',
  SYSTEM_FAILURE = 'SYSTEM_FAILURE',
  PENDING_STIPULATIONS = 'PENDING_STIPULATIONS',
  DEFAULT = 'DEFAULT',
  DECLINED = 'DECLINED',
}

export const UTM_CAMPAIGN = 'utm_campaign'
export const UTM_CAMPAIGN_DETAILS = 'utm_campaign_details'
export const PARTNER_CAMP_ID = 'partner_camp_id'
export const PARTNER_CAMP_EXPIRY = 'partner_camp_expiry'
export const PARTNER_CAMP_EXPIRY_DAYS = 2
export const LEAD_ORIGIN_URL = 'lead_origin_url'

// Route paths
export const DIGITAL_PATH = '/digital'
export const PARTNER_PATH = '/partner'
export const START_PATH = '/:country/:applicationType/start'
export const PRIVACY_POLICY_PAGE_PATH = '/privacy'
export const APPLICATION_PATH = '/application/:country/:applicationType/*'
export const MAINTENANCE_PAGE_PATH = '/maintenance'
export const LANDING_PAGE_PATH = '/merchant-lending/loanbuilder'
export const CAMPAIGN_MIGRATION_OLD = '/campaign_migration'
export const PPBL_REDIRECT = '/ppbl_redirect'
export const CLEVER_CALCULATOR = '/calculator/:applicationType'

export const creditFrozenPageConstants = {
  phoneNumber1: {
    phone: '800-916-8800',
    tel: 'tel:8009168800',
  },
  phoneNumber2: {
    phone: '800-347-5626',
    tel: 'tel:8003475626',
  },
}

export const exampleTotalAnnualBusinessRevenue = 145000

export const sessionTimeoutPageConstants = {
  phoneNumber: {
    phone: '800-941-5614',
    tel: 'tel:800-941-5614',
  },
}

export const maintenancePageConstants = {
  phoneNumber: {
    phone: '1-800-941-5614',
    tel: 'tel:18009415614',
  },
  emailAddress: {
    email: 'customerservice@loanbuilder.com',
    mailto: 'mailto:customerservice@loanbuilder.com',
  },
}

export const discloaureModelConstants = {
  phoneNumber: {
    phone: '800-347-5626',
    tel: 'tel:8003475626',
  },
}

export const openApplicationPageConstants = {
  phoneNumber: {
    phone: '1-800-941-5614',
    tel: 'tel:18009415614',
  },
  emailAddress: {
    email: 'customerservice@loanbuilder.com',
    mailto: 'mailto:customerservice@loanbuilder.com',
  },
}

export const pendingPageConstants = {
  phoneNumber: {
    phone: '1-800-347-5626',
    tel: 'tel:18003475626',
  },
}

export const thankYouPageConstants = {
  phoneNumber: {
    phone: '1-800-941-5614',
    tel: 'tel:18009415614',
  },
}

export enum worldReadyValidationCases {
  MISSING_REQUIRED = 'MISSING_REQUIRED',
  ADDRESS_CONTAINS_PO_BOX = 'ADDRESS_CONTAINS_PO_BOX',
  INVALID_SCRIPT = 'INVALID_SCRIPT',
  INVALID_ALL_NON_VOWEL = 'INVALID_ALL_NON_VOWEL',
  INVALID_MAX_LENGTH_EXCEEDED = 'INVALID_MAX_LENGTH_EXCEEDED',
  PHONE_ALPHA_CHARACTERS = 'PHONE_ALPHA_CHARACTERS',
}

export const errorConstants = {
  OPEN_APPLICATIONS_EXIST: 'OPEN_APPLICATIONS_EXIST',
  SESSION_TIMEOUT_STATUS_CODES: [401, 403],
  USER_ACCOUNT_TYPE_UNSUPPORTED: 'User account type is not suppoprted',
}

export const AUTO_QUALIFICATION_FAILURE_REASONS_MAP = {
  ATTUS_FAILURE: 'ATTUS Failure',
  BANK_ACCOUNT_INELIGIBLE: 'Bank account on file ineligible for automation',
  BANK_ACCOUNT_NOT_VERIFIED: 'Bank Account Not Verified',
  EXISTING_ACTIVE_CREDIT_ACCOUNT: 'Existing Open Account',
  FRAUD_CASE: 'Fraud Case',
  KNOWLEDGE_BASED_AUTHENTICATION_FAILURE:
    'Knowledge-Based Authentication Failure',
  KYC_VERIFICATION_GAPS: 'KYC Verification Gaps',
  MATERIAL_CONTRACT_CHANGE: 'Material Contract Change',
  NEEDS_UNDERWRITING_REVIEW: 'Needs UW Review',
  NOT_APPLICABLE_DUE_TO_RISK_RULES:
    'Automation currently not available due to Risk Rules',
  OFFER_OUT_OF_SCOPE: 'Offer Out Of Automation Scope',
  PRODUCT_NOT_ELIGIBLE: 'Product Not Qualified For Automation',
  REPAYMENT_BANK_ACCOUNT_NOT_VERIFIED: 'Repayment Bank Account Not Verified',
}

export const footerCtaSectionContants = {
  phoneNumber: {
    contact: '800-941-5614',
    tel: '8009415614',
  },
}

export enum weekDays {
  STARTDAY_MONDAY = 'MONDAY',
  ENDDAY_FRIDAY = 'FRIDAY',
}

export enum addressStatus {
  CORRECTED = 'CORRECTED',
  INVALID = 'INVALID',
  VERIFIED = 'VERIFIED',
}

export const addressDialogConstants = {
  recommendedAddress: 'RECOMMENDED',
  enteredAddress: 'ENTERED',
}
